<template>
  <main>
    <div class="container">
        <div class="news-card">
            <div class="news-date">{{ $t('News.date') }}</div>
            <h1 class="news-title">{{ $t('News.title') }}</h1>

            <div class="news-content">
                <p>{{ $t('News.text1') }}</p>

                <div class="highlight">
                    {{ $t('News.text2') }}
                </div>

                <p>{{ $t('News.text3') }}</p>

                <p>{{ $t('News.text4') }}</p>

                <p>{{ $t('News.text5') }}</p>
            </div>

            <div class="news-tag">{{ $t('News.tag') }}</div>
        </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'News',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
        }

        main {
            padding: 100px 0;
        }

        .news-card {
            background-color: white;
            border-radius: 12px;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
            padding: 40px;
            margin-bottom: 40px;
            border-top: 5px solid #4a90e2;
        }

        .news-date {
            color: #2c6cb0;
            font-size: 16px;
            margin-bottom: 10px;
            font-weight: 600;
        }

        .news-title {
            color: #1a4b8c;
            font-size: 28px;
            margin-bottom: 25px;
            line-height: 1.3;
        }

        .news-content {
            font-size: 17px;
            margin-bottom: 30px;
        }

        .news-content p {
            margin-bottom: 20px;
        }

        .highlight {
            background-color: #e8f2fc;
            padding: 20px;
            border-left: 4px solid #4a90e2;
            margin: 25px 0;
            border-radius: 0 8px 8px 0;
        }

        .news-tag {
            display: inline-block;
            background-color: #e8f2fc;
            color: #1a4b8c;
            padding: 6px 15px;
            border-radius: 20px;
            font-size: 14px;
            font-weight: 600;
            margin-top: 10px;
        }

        @media (max-width: 768px) {
            .news-card {
                padding: 25px;
            }

            .news-title {
                font-size: 24px;
            }
        }
</style>
